import { ErrorModal } from "@/components/shared/modal/error-modal";
import Grid from "@material-ui/core/Grid";
import * as React from "react";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useLocationsContext } from "../locations/context/Location";
import { getLocations } from "../locations/repositories/Location";
import { useRootTypeContext } from "../rootTypes/context/RootTypeContext";
import { getRootTypes } from "../rootTypes/repositories/RootTypes";
import { TableRoots } from "./components/DataTable/TableRoots";
import { useRootContext } from "./context/RootContext";
import { useRootStateContext } from "./context/RootStateContext";
import { getRoots } from "./repositories/Root";
import { getRootStates } from "./repositories/RootState";

export const Roots = () => {
	const { state, actions } = useRootContext();
	const { state: rootTypes, actions: rootTypesActions } = useRootTypeContext();
	const { state: rootStates, actions: rootStatesActions } =
		useRootStateContext();
	const { state: locations, actions: locationActions } = useLocationsContext();
	const [isLoading, setIsLoading] = useState(true);

	const [showErrorModal, setShowErrorModal] = useState(false);
	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getRootsFromAPI = async () => {
		setIsLoading(true);

		const values = await Promise.all([
			getRoots(),
			getRootTypes(),
			getRootStates(),
			getLocations(),
		])
			.then((r) => {
				const [rootsResp, rootTypeResp, rootStateResp, locationResp] = r;

				if (
					rootsResp.ok &&
					rootTypeResp.ok &&
					locationResp.ok &&
					rootStateResp.ok
				) {
					actions.setRoots(rootsResp?.roots);
					rootTypesActions.setRootTypes(rootTypeResp?.rootTypes);
					rootStatesActions.setRootStates(rootStateResp?.rootStates);
					locationActions.setLocations(locationResp?.locations);
					setIsLoading(false);
				}
			})
			.catch((e) => {
				setFetchDataError(e);
				setShowErrorModal(true);
			});
	};

	useEffect(() => {
		getRootsFromAPI();
	}, []);

	if (state.roots) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: 0 }}>
						<div style={{ width: "100%", padding: "10px 0 20px" }}>
							<TableRoots
								isLoading={isLoading}
								getRootsFromAPI={getRootsFromAPI}
							/>
						</div>
						<Outlet />
					</Grid>
				</Grid>
				<ErrorModal
					onHide={() => setFetchDataError(null)}
					error={fetchDataError}
				/>
			</>
		);
	}
	return <></>;
};
